<template>
    <div>
        <a-row :gutter="24" type="flex">
            <a-col :span="24" class="mb-24">
                <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
                    <template #title>
                        <a-row type="flex" align="middle">
                            <a-col :span="24" :md="12">
                                <h5 class="font-semibold m-0">جدول مشخصات</h5>
                            </a-col>
                            <a-col :span="24" :md="12"
                                style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                ">
                                <a-button class="btn-outline-purple" icon="search" @click="isHidden = !isHidden">
                                    جستجو
                                </a-button>
                                &nbsp;

                                <a-button href="/specifications/add" class="btn-outline-blue" icon="plus" v-show="$root.hasPermission('/specifications/add/')" >
                                    افزودن مشخصات
                                </a-button>
                                &nbsp;
                            
                            </a-col>
                        </a-row>
                    </template>

                    <b-card style="margin:20px; !important ; border:none;" v-if="isHidden">
                        <a-col style="margin-top: 20px" :md="3">
                            <a-button class="btn-outline-green w-100" icon="search" @click="getData">
                                جستجو
                            </a-button>

                        </a-col>
                            <a-col :md="7">
                                <label class="sr-only" for="inline-form-input-name"> دسته بندی</label>
                                <select class="form-control" v-model="search.category_id">
                                    <option value="">انتخاب</option>
                                    <option v-for="cat in cats" :value="cat.id">{{ cat . title }}</option>

                                </select>
                            </a-col>
                            <a-col :md="7">
                                <label class="sr-only" for="inline-form-input-name"> نوع مشخصه</label>
                                <select class="form-control" v-model="search.parent_id">
                                    <option value="">انتخاب</option>
                                    <option v-for="parent in parents" :value="parent.id">{{ parent . title }}
                                    </option>

                                </select>
                            </a-col>

                            <a-col :md="7">
                                <label class="sr-only" for="inline-form-input-name">
                                    عنوان</label>
                                <b-form-input v-model="search.title" id="inline-form-input-name"
                                    class="mb-2 mr-sm-2 mb-sm-0"></b-form-input>
                            </a-col>


                    </b-card>
                    <a-row style="justify-content: center; display: flex" v-if="$store.state.loading">
                        <template>
                            <div>
                                <a-spin />
                            </div>
                        </template>
                    </a-row>
                    <div v-else>
                        <section class="w-100 p-4 text-center">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">شناسه</th>
                                        <th scope="col">عنوان</th>
                                        <th scope="col"> مقادیر</th>
                                        <th scope="col">فعال کردن </th>

                                        <th scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="row in data">
                                        <th scope="row">#{{ row . id }}</th>
                                        <td>


                                            <b-badge variant="light" class="text-dark">{{ row . title }}</b-badge>
                                        </td>

                                        <td>
                                            <a-tag v-for="val in row.values" closable  v-show="$root.hasPermission('/specifications/delete/')" 
                                                @close="deleteRow(`specifications/delete/${val.id}`)">
                                                {{ val . title }}
                                            </a-tag>
                                            <a-input class="d-none" :id="'input' + row.id" type="text"
                                                size="small" style="width:78px;" 
                                                @keyup.enter="handleInputConfirm(row.id)" />
                                            <a-tag :id="'button' + row.id" @click="showInput(row.id)"  v-show="$root.hasPermission('/specifications/add/')" 
                                                style="background: #fff; borderStyle: dashed;">
                                                <a-icon type="plus" /> مقدار جدید
                                            </a-tag>
                                        </td>
                                        <td>
                      <a-switch @change="changeStatus(row.id)" v-model="row.status" :disabled="!$root.hasPermission('/specifications/status/')" />

                    </td>
                                        <td>

                                            <a-button class="btn-outline-warning" shape="square" icon="edit" 
                                            v-show="$root.hasPermission('/specifications/edit/')"
                                                :href="'/specifications/edit/' + row.id" />
                                            &nbsp;
                                            <!-- <a-button class="btn-outline-danger" shape="square" icon="delete"
                                            v-show="$root.hasPermission('/specifications/delete/')"
                                                @click="deleteRow(`specifications/delete/${row.id}`)"></a-button> -->
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </section>
                        <a-row class="pagination">
                            <a-pagination :total="total" :item-render="$root.itemRender"
                                @change="getData(currentPage)" v-model="currentPage" />
                        </a-row>
                    </div>
                </a-card>
            </a-col>
        </a-row>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data: [],
                visible: false,

                parents: [],
                cats: [],
                currentPage: 1,
                total: 0,
                isHidden: false,
                search: {
                    title: "",
                    parent_id: "",
                    category_id: "",
                },
                inputVisible: false,
                inputValue: [],
            };
        },
        methods: {
            async getData() {
                let _this = this;
                this.$store.state.loading = true;
                let url =
                    `/specifications?page=${this.currentPage}&&title=${this.search.title}&&parent_id=${this.search.parent_id}&&category_id=${this.search.category_id}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.data = response.data.data;
                        _this.$store.state.loading = false;
                        _this.total = response.data.total;
                        _this.currentPage = response.data.current_page;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },

            async getAll() {
                let _this = this;
                let url = '/specifications/all';
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.parents = response.data.data;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            async getCats() {
                let _this = this;
                let url = '/categories/all';
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.cats = response.data.data;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },

            deleteRow(url) {
                this.$swal({
                    title: "آیا از حذف اطلاعات اطمینان دارید؟",
                    showDenyButton: true,
                    showCancelButton: false,
                    confirmButtonText: "بله",
                    denyButtonText: "لغو",
                }).then((result) => {
                    if (result.isConfirmed) {
                        let _this = this;
                        axios
                            .get(url)
                            .then(function(response) {
                                _this.$toast.success("با موفقیت حذف شد.");
                                _this.getData();
                            })
                            .catch(function(err) {
                                _this.$root.handleAxiosError(err);
                            });
                    }
                });
            },
            async changeStatus(id){
              let _this = this;
                this.$store.state.loading = true;
                let url =
                    `/specifications/status/${id}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.getData();
                        _this.$toast.success(" مشخصه مورد نظر با موفقیت ویرایش شد.");

                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            showInput(id) {
                document.getElementById('input' + id).classList.toggle("d-none");
                document.getElementById('button' + id).classList.toggle("d-none");
            },
            handleInputConfirm(id) {
              let _this=this;
                const inputValue = document.getElementById('input' + id).value;
                let data = new FormData();
                data.append("title", inputValue);
                data.append("parent_id", id);
                axios
                    .post("/specifications/add", data)
                    .then(function(response) {
                        _this.$root.loading = false;
                        _this.$toast.success("مقدار با موفقیت ذخیره شد");
                        _this.getData();
                    })
                    .catch(function(err) {
                        _this.$root.loading = false;
                        _this.$root.handleAxiosError(err);
                    });
            },
        },
        mounted() {
            this.getAll();
            this.getData();
            this.getCats();
        },
    };
</script>

<style scope>
    .pagination {
        display: flex;
        justify-content: center;
        margin: 15px;
    }
</style>
